// extracted by mini-css-extract-plugin
export default {"Button":"RjrKXwB0fJbtOfaJtM0A","hasShadow":"VvWRKbXfvmDBkUmIl8S5"};